'use client';
import React, { createContext, useState, useMemo } from 'react';
import { CustomerResponse } from '@/components/customercenter-ui/components/customer-detail/types';

const InitialCreditSummary = {} as any;
const CreditSummaryContext = createContext(InitialCreditSummary);

const CreditSummaryProvider = ({ children }: React.PropsWithChildren) => {
  const [customerData, setCustomerData] = useState<CustomerResponse>();
  const [customerDetailsResponse, setCustomerDetailsResponse] = useState(null);
  const contextValue = useMemo(
    () => ({ customerData, setCustomerData, customerDetailsResponse, setCustomerDetailsResponse }),
    [customerData, customerDetailsResponse],
  );

  return <CreditSummaryContext.Provider value={contextValue}>{children}</CreditSummaryContext.Provider>;
};

export { CreditSummaryContext, CreditSummaryProvider };
